import { render, staticRenderFns } from "./packages-mobile.vue?vue&type=template&id=12d9a987&scoped=true&"
import script from "./packages-mobile.vue?vue&type=script&lang=js&"
export * from "./packages-mobile.vue?vue&type=script&lang=js&"
import style0 from "./packages-mobile.vue?vue&type=style&index=0&id=12d9a987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9a987",
  null
  
)

export default component.exports